import $ from 'jquery';

window._fiUser = window._fiUser || new FIUser();
function _propertyDefaultsData(properties) {
	return $.extend({
		value: "",
		enumerable: true,
		writable: true,
		configurable: false
	}, properties);
}

//------------------
// helper to use cookies
//------------------
function _setCookie(key, jsonData, expiryDays, path, domain, secure) {
	if((key && jsonData)) {
		var cookieString = key + "=" + encodeURIComponent(JSON.stringify(jsonData));
		if(expiryDays !== undefined) {
			var expirationDate = new Date();
			expirationDate.setTime(expirationDate.getTime() + (expiryDays * 86400000));
			cookieString += "; expires=" + expirationDate.toUTCString();
		}
		cookieString += path !== undefined ? "; path=" + path : "";
		cookieString += domain !== undefined ? "; domain=" + domain : "";
		cookieString += secure ? "; secure" : "";
		document.cookie = cookieString;
	}
	return jsonData;
}

function _getCookie(key) {
	if(key !== undefined) {
		var value = document.cookie.match( '(^|;) ?' + key + '=([^;]*)(;|$)');
		if(value !== null) {
			return JSON.parse(decodeURIComponent(value[2]));
		}
	}
	return null;
}

function _deleteCookie(key) {
	_setCookie(key, {}, -10, undefined, 'plinqit.com', undefined);
}

//Variable checker function
function isEmpty(value) {
	return (typeof value === 'undefined' || value === 'undefined' || value === undefined || value === null || value === '');
}


async function sha512(str) {
  return await crypto.subtle.digest("SHA-512", new TextEncoder("utf-8").encode(str)).then(buf => {
    return Array.prototype.map.call(new Uint8Array(buf), x=>(('00'+x.toString(16)).slice(-2))).join('');
  });
}

function FIUser(options) {

	Object.defineProperty(this, "id", _propertyDefaultsData({ value : ""}));
	Object.defineProperty(this, "email", _propertyDefaultsData({ value : "" }));
	Object.defineProperty(this, "hashPass", _propertyDefaultsData({ value : "" }));
	Object.defineProperty(this, "firstname", _propertyDefaultsData({ value : "" }));
	Object.defineProperty(this, "lastname", _propertyDefaultsData({ value : "" }));
	Object.defineProperty(this, "sponsorid", _propertyDefaultsData({ value : "" }));
	Object.defineProperty(this, "linked_ids", _propertyDefaultsData({ value : [] }));
	Object.defineProperty(this, "token", _propertyDefaultsData({ value : "" }));
	Object.defineProperty(this, "role", _propertyDefaultsData({ value: "" }));
	Object.defineProperty(this, "job_title", _propertyDefaultsData({ value : "" }));
	Object.defineProperty(this, "status", _propertyDefaultsData({ value : "" }));


	// sync data
	function syncData(me, data) {
		// Initialize the object
		var defaults = $.extend({
			id : '',
			email : '',
			hashPass : '',
			firstname : '',
			lastname : '',
			sponsorid : '',
			linked_ids : [],
			token : '',
			role : '',
			job_title : '',
			status : ''
		}, data);

		
		me.id = defaults.id;
		me.email = defaults.email;
		me.hashPass = (defaults.hashPass && defaults.hashPass.length) ? defaults.hashPass : me.hashPass;
		me.firstname = defaults.firstname;
		me.lastname  = defaults.lastname;
		me.sponsorid = defaults.sponsorid;
		me.linked_ids = defaults.linked_ids;
		me.token = (defaults.token && defaults.token.length) ? defaults.token : me.token;
		me.role = defaults.role;
		me.job_title = defaults.job_title;
		me.status = defaults.status;

	}

	//Check admin token
	this.ADMIN_CHECK = function() {
		var adminCookie = _getCookie('admin');

		return adminCookie.token.length > 0;
	}

	//Login 
	this.LOGIN = function(email, password, cb) {
		/*var me = this;

		sha512(password).then(function(result) {
			me.hashPass = result;
		});

		var ssodata = "<form id='sso-login-form' method='POST' action='" + window.app.ssourl + "'><input name='username' type='text' value='" + email + "' /><input name='password' type='text' value='" + password + "' /></form>";

	    $('.Login-Body').append(ssodata);
	    $('#sso-login-form').submit();
		*/var me = this;

		sha512(password).then(function(result) {
			me.hashPass = result;
		});

		$.ajax({
		  type : 'POST',
		  data : {email : email, password: password},
		  url : window.app.apiurl + 'filogin',
		  dataType: 'json',
		  success : function(response) {
		    if(response.data) {
		      
		      syncData(me, response.data);
		      me.saveSessionInfo();
		    }
		  },
		  error : function(response) {
		    
		  },
		  complete(response) {
		  	if(cb) cb(response.responseJSON);
		  }
		});
	}
	//User getter
	this.GET = function(cb) {
		var headers = {
			'User-Token' : this.token,
			'Client-Portal' : true
		};

		var me = this;

		$.ajax({
			url: window.app.apiurl + "FIUsers/" + window._fiUser.id,
			type : 'GET',
			headers : headers,
			dataType : 'json',
			success : function (response) {
				
				if(response.code === 200) {
					syncData(me, response.data);
					me.saveSessionInfo();
				}

				if(response.detail === 'expired') {
					window.location.pathname = '/Logout';
				}
			},
			error : function(response) {
				////console.log(response); //For Debug! Remove
				if(response.detail === 'expired') {
					window.location.pathname = '/Logout';
				}
			},
			complete : function(response) {
				
				if(cb) cb(response.responseJSON);
			}

		});
	};

	//User updater
	this.UPDATE = function(cb, new_password = '') {
		var headers = {
			'User-Token' : this.token,
			'Client-Portal' : true
		};

		var me = this;

		var data = {
			email : this.email,
			firstname : this.firstname,
			lastname : this.lastname,
			job_title : this.job_title
		};

		if (new_password) data.password = new_password;

		$.ajax({
			url: window.app.apiurl + "FIUsers/" + window._fiUser.id,
			type : 'PUT',
			headers: headers,
			data: JSON.stringify(data),
			dataType: 'json',
			contentType: "application/json",
			success: function(response) {
				if(response.code === 200) {
					me.saveSessionInfo();
				}
			},
			error: function(response) {
				////console.log(response); //FOR DEBUG!
			},
			complete: function(response) {
				if(cb) cb(response.responseJSON);
			}

		});
	}

	this.CHECK_TOKEN = function(cb) {

		var headers = {
			'User-Token' : this.token,
			'Client-Portal' : true
		};

		var me = this;

		if(this.token.length === 0 || this.id.length === 0) {
			window.location.pathname = '/Logout';
		}

		$.ajax({
			url: window.app.apiurl + 'FIUsers/' + me.id + '/checktoken',
			type : 'GET',
			headers : headers,
			dataType: 'json',
			contentType: false,
			success: function(response) {
				if(response.detail === 'expired') {
					window.location.pathname = '/Logout';
				}
			},
			error : function(response) {
				////console.log(response); //For Debug! Remove
				if(response.detail === 'expired') {
					window.location.pathname = '/Logout';
				}
			},
			complete: function(response) {
				if(response.responseJSON.detail !== 'expired') {
					if(cb) cb(response);
				}
			}
		})
	}

	// Reset Password
	this.resetPassword = function(email, cb) {
		var headers = {
			//'Client-Portal' : true
		};

		//var me = this;

		var data = {
			email : email
		};

		$.ajax({
			url: window.app.apiurl + "mail/fiforgotpassword/",
			type : 'POST',
			headers: headers,
			data: JSON.stringify(data),
			dataType: 'json',
			contentType: "application/json",
			success: function(response) {
				if(response.code === 200) {

				}
			},
			error: function(repsonse) {

			},
			complete: function(response) {
				if(cb) cb(response.responseJSON);
			}
		});
	}

	// load session token
	this.loadSessionInfo = function() {
		
		var sessionData = JSON.parse(sessionStorage.getItem('_fiUser'));;
		////console.log(sessionData);
		if(!isEmpty(sessionData)) {
			syncData(this, sessionData);
			return true;
		}

		var sessionStData = _getCookie("ht_user_pqd")
		if(!isEmpty(sessionStData))
		{
			this.token = sessionStData.token;
			this.id = sessionStData.id;
			return true;
		}

		/*var ssoData = _getCookie("admin");
		if(!isEmpty(ssoData)) {
			console.log(ssoData);
			this.token = ssoData.token;
			this.id = ssoData.dbkey;
			return true;
		}*/

		return false;
	};

	// save session token
	this.saveSessionInfo = function() {
		_setCookie("ht_user_pqd", {
			token : this.token,
			id : this.id
		}, 7, undefined, undefined, true);
		
		sessionStorage.setItem('_fiUser', JSON.stringify(this));
	};

	this.deleteSessionInfo = function() {
		console.log('***Deleting session info!');
		this.token = '';
		this.id = '';
		this.email = '';
		this.firstname = '';
		this.lastname = '';
		this.sponsorid = '';
		this.role = '';
		this.job_title = '';
		this.status = '';
		
		sessionStorage.removeItem('_fiUser');
		_deleteCookie("ht_user_pqd");
		_deleteCookie("admin");
	};

	// check if user is logged in
	this.isLoggedIn = function() {
		return this.token !== "";
	};


	syncData(this, options);
}

export {_propertyDefaultsData, _getCookie, _setCookie, _deleteCookie, isEmpty, sha512};